import React from "react";
import "./conclave css files/attendeessection.css";
const green_dot = require("../../assets/conclave assets/yellow_dots.png");
const fifth_angle_img = require("../../assets/conclave assets/Attendees_Banner.png");
const design_9 = require("../../assets/conclave assets/yello_polygon.png");
const desgin_dotted_grey = require("../../assets/conclave assets/gray_dots.png");

function AttendeesSection(props) {
  return (
    <div className="attendance_main_container" id="attendees">
      <div className="attendance_under_main_container">
        <div className="design_dotted_contaier_grey">
          <img src={desgin_dotted_grey} alt="design" />
        </div>
        <div className="attendance_img_content_container">
          <div className="img_attendees_container">
            <div className="img_fifthangle_container">
              <img src={fifth_angle_img} alt="attendees_img" loading="lazy" />
            </div>
          </div>

          <div className="content_attendees_container">
            <div className="design_green_text_container">
              <div className="green_dott_design_container">
                <div className="green_design_dot_container">
                  <img src={green_dot} alt="green_dot" />
                </div>
                <div className="design_9_container1">
                  <img src={design_9} alt="design_9" />
                </div>
              </div>
              <p className="green_text_attendees">Attendees</p>
            </div>

            <div className="content_attendees_all_text">
              <p className="attend_title_text">Government Dignitaries</p>
              <div className="number_paragraph_text_container">
                <strong className="attend_strong_yellow_text">10+</strong>
                <p className="attend_extra_text">
                  Chairman,Directors,Heads of Regulatory bodies <br />
                  Educational Secretaries , Education Regulatory Bodies
                </p>
              </div>
            </div>
            <div className="content_attendees_all_text1">
              <p className="attend_title_text">Higher Education</p>
              <div className="number_paragraph_text_container">
                <strong className="attend_strong_yellow_text">150+</strong>
                <p className="attend_extra_text">
                  Chairman,Chancellors,Vice-Chancellors,
                  <br />
                  Directors, etc. from Indian Universities & Colleges
                </p>
              </div>
            </div>
            <div className="content_overseas_text_container">
              <p className="attend_title_text">
                Overseas <br /> Universities{" "}
                <strong className="attend_strong_yellow_text">20+</strong>
              </p>
            </div>

            <div className="leader_text_container">
              <strong className="attend_title_text">Corporate Leaders</strong>
              <p className="attend_extra_text">
                Life & Business Coaches, Corporate HR domain experts
              </p>
            </div>

            <div className="speaker_container_text">
              <p className="attend_title_text">Speakers</p>
              <strong className="attend_strong_yellow_text">20+</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AttendeesSection;
